import { GET_REPORT_ERROR_REQUEST } from '../constants/action-types';

export const addReportError = (itemId, categoryId) => ({
  type: GET_REPORT_ERROR_REQUEST,
  itemId,
  categoryId,
});
